/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VisibilityAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Hide from './Hide/index'
import React from 'react'
import Show from './Show/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VisibilityAction({
  children,
  viewPath = "/App/Auth/SignIn/Credentials/Password/VisibilityAction"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Hide'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<button
  data-testid="VisibilityAction.Horizontal"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, 'Show')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, 'Hide')) : () => setFlowTo(fromFlow.normalizePath(viewPath, 'Show'))}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={flowValue === 'Hide'}>
<Hide
  viewPath={`${viewPath}/Hide`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Show'}>
<Show
  viewPath={`${viewPath}/Show`}
/>
</fromFlow.When>
</button>
{children}
</React.Fragment>)
}